import { render } from "./RealestatesListView.vue?vue&type=template&id=43de4d3b"
import script from "./RealestatesListView.vue?vue&type=script&lang=js"
export * from "./RealestatesListView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__